export default __webpack_public_path__ + "static/media/diceSmall.b8eb9f5b.svg";